import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import ClientName from './title/client_name/ClientName';
import ClientDetails from './client_details/ClientDetails';

const ClientHeader = (props) => {
  const {
    clientRn,
    clientData,
    clientForms,
    clientLogs,
    clientBackend,
    clientCareplan,
    clientCallStatus,
    clientOwnerData,
    refresh,
    setRefresh,
  } = props;

  return (
    <Stack gap={1}>
      <ClientName
        clientData={clientData}
        clientBackend={clientBackend}
      />
      <ClientDetails
        clientRn={clientRn}
        clientForms={clientForms}
        clientLogs={clientLogs}
        clientCareplan={clientCareplan}
        clientData={clientData}
        clientBackend={clientBackend}
        clientCallStatus={clientCallStatus}
        clientOwnerData={clientOwnerData}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </Stack>
  );
};
ClientHeader.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  clientForms: PropTypes.array,
  clientLogs: PropTypes.object.isRequired,
  clientCareplan: PropTypes.object,
  clientBackend: PropTypes.object.isRequired,
  clientCallStatus: PropTypes.string,
  clientOwnerData: PropTypes.object,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(ClientHeader);
